module.exports = "<div [innerHtml]=\"paperHtml | sanitizeHtml\"></div>\n"